import React from "react";
import BaseTooltip from "../BaseTooltip";
import dayjs from "dayjs";
import { formatInvoiceStatus } from "../../../utils/helpers";
import { UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";

const BaseInvoiceStatus = ({ status, statusHistory = [], isCustomer = false }) => {
  const statusClassMap = {
    GENERATED: "text-blue-600 bg-blue-100",
    VERIFIED: "text-purple-600 bg-purple-100",
    UNPAID: "text-amber-600 bg-amber-100",
    OVERDUE: "text-red-600 bg-red-100",
    PAID: "text-green-600 bg-green-100",
  };

  // The same invoice reads differently from the customer's side of the flow: the
  // client verifying it is what puts it in front of them ("Received"), and the
  // customer sending it on is what approves it ("Approved"). The client's own
  // drafting step is not theirs to see, so it is dropped from the history tooltip.
  const customerLabels = { VERIFIED: "Received", UNPAID: "Approved" };
  const customerClasses = { VERIFIED: statusClassMap.GENERATED };

  const labelFor = (value) => (isCustomer && customerLabels[value]) || formatInvoiceStatus(value);
  const classFor = (value) => (isCustomer && customerClasses[value]) || statusClassMap[value];

  // UNPAID is written by two different actions that read as one status: the
  // client sending the invoice, and the customer approving it. On the client's
  // side those are distinct steps, so the history names what was done — only the
  // actor's role separates them. From the customer's side the invoice reaching
  // UNPAID is what "approved" means either way, so theirs always reads Approved.
  // The chip itself still shows the status.
  const historyLabel = (item) => {
    if (isCustomer || item.newStatus !== "UNPAID") return labelFor(item.newStatus);
    return item.changedBy?.role?.role === UserType.CUSTOMER ? "Approved" : "Sent";
  };

  const displayHistory = isCustomer
    ? statusHistory?.filter((item) => item.newStatus !== "GENERATED")
    : statusHistory;

  /*  {user?.personalAddress?.addressLine1 && (
            <BaseTooltip
              position="top"
              interactive={true}
              content={
                <p className="text-white">{`${user?.personalAddress?.addressLine1}`}</p>
              }
            >
              <div
                className="flex bg-[#E7FFF4] py-1 px-3 rounded-md mr-6 cursor-pointer"
                onClick={openGooglMapLocation}
              >
                <i className="fa-solid fa-location-dot text-[#147648] text-sm"></i>
                <p className="text-[#147648] text-sm ml-2 truncate max-w-64 overflow-hidden whitespace-nowrap">
                  {user?.personalAddress?.addressLine1}
                </p>
              </div>
            </BaseTooltip>
          )} */
  return (
    <p
      className={`px-2 text-center py-[3px] h-[24px] flex items-center justify-center rounded-[4px] font-normal ${classFor(status)}`}
    >
      {labelFor(status)}
      {displayHistory?.length > 0 && (
        <BaseTooltip
          // className="z-50"
          placement="right"
          interactive={true}
          content={
            <div>
              {displayHistory?.map((item) => (
                <p className="text-white text-left">{`${historyLabel(item)}\n By: ${item.changedBy.firstName} ${item.changedBy.lastName}`}</p>
              ))}
            </div>
          }
        >
          <i className={`fa-solid fa-circle-info ml-2 cursor-pointer ${classFor(status)}`}></i>
        </BaseTooltip>
      )}
    </p>
  );
};

export default BaseInvoiceStatus;
